module.exports = __webpack_public_path__ + "img/icon_2_32.6745df6b.png";